import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"

import FieldTaskType_QuickFilterView from "./render/quick-filter-view"
import FieldTaskType_View from "./render/view"
import FieldDropdown from "../../../generic/dropdown/dropdown"
import FieldTaskType_GraphTickLabelView from "./render/graph-tick-label"
import FieldTaskType_CSVImportPreview from "./render/csv-import-preview";
import FieldTaskType_TableCell from "./render/table/table-cell";
import FieldTaskType_PopoverMore from "./components/popover/popover-menu-more";
import Task from "../../../../model2/task/task";
import FieldTaskType_Editable from "./render/editable/editable";
import ItemModel from "../../../../model2/item/item-model";
import TableManager from "../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../gd-modules/task-list/manager/manager";
import {LifecycleAction} from "../../../../gd/const/lifecycle"
import {SortDirection} from "../../../../data-structures/sort"

export default class FieldTaskType extends FieldDropdown {

    // QUICK_FILTER_CLASS = TaskTypeQuickFilter

    constructor(config:any) {
        super(config)

        this.typeLabel          = "Task Type"
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Task type"
        this.icon               = 'i5-task'

        this.options            = _.get(config,'options',null);
        if (!this.options) {
            // this.options        = gd.session.taskTypes.exportOptions() -- OLD icon
            this.options        = gd.session.taskTypes.exportToOptions()    // all all all options
        }

        this.noValueOption      = false;
        this.isSearchable       = false;


        // mmm... disabled nado podumat' chto s etim delat'
        this.components.PopoverMenuMore         = this.showMenuMore ? FieldTaskType_PopoverMore : null



        this.renderComponents.quickFilterView   = FieldTaskType_QuickFilterView
        this.renderComponents.view              = FieldTaskType_View
        this.renderComponents.viewSmall         = FieldTaskType_View

        this.renderComponents.graphTickLabelView= FieldTaskType_GraphTickLabelView
        this.renderComponents.csvImportPreview  = FieldTaskType_CSVImportPreview
        this.renderComponents.tableCell         = FieldTaskType_TableCell
        this.renderComponents.editable          = FieldTaskType_Editable


        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange

    }

    // ACCESS

    canEdit(model:Task) {
        return model.acl.canChangeTaskType
    }



    // OPTIONS

    getOptionsForEdit(model:Task):Option[] {

        // Technically it's a patch ... in future use FormModel...
        // In some cases we use this field without model i.e. select task type in new task or Request Form settings
        if (!model || !model.projectId) {
            return this.options?.slice(0) as Option[]
        }

        // Standard case when model passed
        const allowedTaskTypeIds : ID[] = gd.session.projects.get(model.projectId)!.getInheritedTaskTypes()

        return _.filter(this.options, (taskTypeOption:Option)=>{
            return allowedTaskTypeIds.includes(taskTypeOption.value as ID)
        })


    }

    // TABLE
    tableCellOnValueChange = async (item:ItemModel, value:any, manager:TableManager|TaskListManager) => {

        // item.task.setStartDateAndKeepCalendarDuration(value)

        item.task.taskTypeId = value
        item.task.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        // manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }


    /*** DATA FUNCTIONS ***/

    groupValue(value:any) {
        return value
    }

    groupLabel(value:any) {
        const taskType = gd.session.taskTypes.get(value);
        return taskType ? taskType.name : ''
    }

    getGroupObject(value: any) {
        const found = gd.session.taskTypes.get(value)

        return {
            id      : found ? found.id : value,
            value   : found ? found.id : value,
            label   : found ? found.name : value,
            name    : _.get(found, 'name', 'Not defined'),
        }
    }

    sortValue(value:any) {
        const taskType = gd.session.taskTypes.get(value);
        return taskType ? taskType.name.toLowerCase() : ''
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem:ItemModel) => listItem.isTask ? gd.session.taskTypes.get(listItem.task.taskTypeId)?.sortPosition : 0,
                (listItem:ItemModel) => listItem.isTask ? gd.session.taskTypes.get(listItem.task.taskTypeId)?.name.toLowerCase() : 0,
            ],
            directions  : [sort, sort]
        }
    }
}
